import { SecureNetCalculator } from '@teliaee/telia-common-components';
import { observer } from 'mobx-react';
import React from 'react';
import Config from '../Config';
import { useStores } from '../stores/RootStore';

export interface SecureInternetCalculatorProps {
  disableTranslationsStatistics?: boolean;
  isTestEnvironment?: boolean;
  showAddressSearchPopUpInLiveEnv?: boolean;
}

const SecureInternetCalculator = observer((props: SecureInternetCalculatorProps) => {
  const { languageStore, ssoStore, routeStore, contentStore } = useStores();
  const { disableTranslationsStatistics, isTestEnvironment, showAddressSearchPopUpInLiveEnv } = props;
  const params = routeStore.decodedParams;
  return (
    <SecureNetCalculator
      app={'public'}
      tier={Config.componentTier}
      language={languageStore.currentLanguage}
      auth={ssoStore.personAndCustomerInfo}
      openSsoFrame={ssoStore.openSsoFrame}
      isSsoLoaded={ssoStore.initialSsoMessageReceived}
      isSsoModalOpen={ssoStore.ssoFrameVisible}
      address={
        params.addressId && params.buildingId
          ? {
              id: params.addressId,
              buildingId: params.buildingId,
            }
          : undefined
      }
      room={params.roomId && params.roomName ? { roomId: params.roomId, roomName: params.roomName } : undefined}
      formsList={contentStore.formsList}
      disableTranslationsStatistics={disableTranslationsStatistics}
      navigate={routeStore.push}
      isTestEnvironment={isTestEnvironment}
      showAddressSearchPopUpInLiveEnv={showAddressSearchPopUpInLiveEnv}
    />
  );
});

export default SecureInternetCalculator;
